import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const JewelryApprisals = () => {
  return (
    <Container>
      <h2 className="font-weight-bold mt-5 mb-3 text-center">Jewelry Appraisals</h2>
      <p>
        Wondering how important your jewelry is? At Khan Diamonds, we provide
        accurate, reliable jewelry testing services. Whether you want to
        investigate a family estate or need a quote on a newly purchased piece,
        we can help you. <br /> <br />
        At Khan Diamonds, our goal is to make the jewelry testing process easier
        and less stressful from start to finish. We have the equipment and
        skills to test stones and various objects. Need a referral test at your
        insurance company? <br /> <br />
        We will present our findings in a clear, concise manner. And if you have
        any questions about your jewelry, we will be happy to provide your
        answers. <br /> <br />
        If you are looking for jewelry testing services in Boston, MA, come to
        us for the answers you need. <br /> <br />
        We will provide Appraisal with free quotes to find out what items need
        to be tested. <br /> <br />
        Fast Insurance Change Rates. <br />
      </p>
      <img 
        src={require("../../../Front/themes/showcase/assets/images/services/appraisal.jpeg")}
        alt="certificate"
        className="img-fluid mx-auto d-table mb-5"
      />
      <Row className="align-items-center">
        <Col md={6}>
          <p>
            Permanent authenticity of precious metals, diamonds and colored
            gemstones. Examination performed and number of jewelery items for
            various purposes and functions. <br /><br />
            Portable gemological equipment allows exploration, identification of
            gemstones and consultation with customers' jewelry on the privacy
            and security of their preferred location. (e.g.) home, bank,
            insurance agency or attorney's office, etc. There is no need for
            jewelry to be missing from your site. There is no need to leave
            precious heirloom jewelry in a jewelry store for days or weeks at a
            time. Most Appraisal is made while you are waiting, Quotes are given
            before the start of the appraisal.
            <br /><br />
            Want to get accurate appraisals for your jewelry? Call or stop by,
            today for more information!
          </p>
        </Col>
        <Col md={6}>
          <img
            src={require("../../../Front/themes/showcase/assets/images/services/khan.png")}
            alt="certificate"
            className="img-fluid"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default JewelryApprisals;
